var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Swap_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71022 19.2696C5.71022 19.8831 6.20242 20.381 6.80887 20.381C7.41533 20.381 7.90753 19.8831 7.90753 19.2696V3.80307L11.4071 7.35632C11.8348 7.79196 12.5292 7.79196 12.9599 7.35928C13.3905 6.92661 13.392 6.22278 12.9628 5.78714L7.58672 0.32687C7.27324 0.00681029 6.79862 -0.0865404 6.38992 0.0838616C5.97829 0.255745 5.71022 0.660265 5.71022 1.11072V19.2696ZM1.43221 7.6832C1.15242 7.6832 0.871167 7.57503 0.657296 7.35869C0.226624 6.92602 0.225159 6.22367 0.654366 5.78803L2.79308 3.61429C3.22228 3.17866 3.91663 3.17866 4.3473 3.61133C4.77651 4.044 4.77798 4.74784 4.35023 5.18347L2.21006 7.35573C1.99619 7.57503 1.71347 7.6832 1.43221 7.6832ZM19.4787 23.9155C19.6134 23.9718 19.7555 24 19.8976 24C20.1847 24 20.466 23.8874 20.6755 23.6725L25.2766 18.9976C25.7044 18.562 25.7029 17.8581 25.2737 17.4254C24.843 16.9928 24.1472 16.9943 23.7195 17.4284L20.9963 20.1978V4.72828C20.9963 4.11483 20.5056 3.61696 19.8976 3.61696C19.2912 3.61696 18.799 4.11483 18.799 4.72828V22.8887C18.799 23.3391 19.0671 23.7437 19.4787 23.9155ZM15.881 20.3833C16.0963 20.6026 16.379 20.7108 16.6603 20.7108C16.9401 20.7108 17.2213 20.6026 17.4352 20.3863C17.8659 19.9536 17.8673 19.2513 17.4396 18.8156L15.3009 16.6419C14.8702 16.2063 14.1759 16.2063 13.7466 16.6389C13.316 17.0716 13.3145 17.7754 13.7422 18.2111L15.881 20.3833Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.091dde96793d08f9ba1d150e5f7738e5.svg";
export { ForwardRef as ReactComponent };